import { useState, useEffect } from 'react';
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';
import Main from '../main/Main';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

function Homepage({ handleLogout, loggedIn }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const username = JSON.parse(localStorage.getItem('uname'));
    let URL = `https://stucharge.bakersbrisk.com/api/getapp?username=${username}`;
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const result = await axios.get(URL, {
      headers: { Authorization: AuthStr },
    });
    if (result.status === 200) {
      localStorage.setItem(
        'app_icon',
        JSON.stringify(result.data.user_details.app_icon)
      );
      localStorage.setItem(
        'subjects',
        JSON.stringify(result.data.user_details.subjects)
      );
    }
  };

  if (!loggedIn) {
    return <Redirect to='/' />;
  }

  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className='container'>
      <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
      <Main />
      <Sidebar
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        handleLogout={handleLogout}
      />
    </div>
  );
}

export default Homepage;
